"use client";
import { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { MoveRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuroraButton } from "./nirmaan/button/aurora-button";
import Link from "next/link";

function Hero() {
  const [titleNumber, setTitleNumber] = useState(0);
  const titles = useMemo(
    () => ["amazing", "new", "wonderful", "beautiful", "smart"],
    [],
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (titleNumber === titles.length - 1) {
        setTitleNumber(0);
      } else {
        setTitleNumber(titleNumber + 1);
      }
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);

  return (
    <div className="w-full">
      <div className="container h-[80vh]  mx-auto">
        <div className="h-full flex gap-8  items-center justify-center flex-col">
          <div>
            <Link href="/docs" className="flex items-center gap-4">
              <Button variant="secondary" size="sm" className="gap-4">
                Installation guide
                <MoveRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
          <div className="flex gap-4 flex-col">
            <h1 className="text-5xl md:text-7xl max-w-2xl tracking-tighter text-center font-regular">
              <span className="text-spektr-cyan-50">This is something</span>
              <span className="relative flex w-full justify-center overflow-hidden text-center md:pb-4 md:pt-1">
                &nbsp;
                {titles.map((title, index) => (
                  <motion.span
                    key={index}
                    className="absolute font-semibold"
                    initial={{ opacity: 0, y: "-100" }}
                    transition={{ type: "spring", stiffness: 50 }}
                    animate={
                      titleNumber === index
                        ? {
                            y: 0,
                            opacity: 1,
                          }
                        : {
                            y: titleNumber > index ? -150 : 150,
                            opacity: 0,
                          }
                    }
                  >
                    {title}
                  </motion.span>
                ))}
              </span>
            </h1>

            <p className="text-sm md:text-xl leading-relaxed tracking-tighter md:tracking-tight text-muted-foreground max-w-2xl text-center">
              Not just another component library, but a bold step beyond,
              empowering developers to build faster, smarter, and crazier than
              ever.
            </p>
          </div>
          <div className="flex flex-row gap-3">
            <Link href="/docs/components/button">
              <AuroraButton aurora className="gap-2">
                <span className="">Get started</span>
                <MoveRight className="w-4 h-4" />
              </AuroraButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Hero };
